import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  AdditionalConfigValidationFunctions,
  ConfigValidationFunction,
} from 'pipelines/step-config-validation/StepConfigValidationTypes';

import validateAggregateConfig from './validateAggregateConfig';
import validateComputedColumnConfig from './validateComputedColumnConfig';
import validateDefineTemplateVariablesConfig from './validateDefineTemplateVariablesConfig';
import validateFilterConfig from './validateFilterConfig';
import validateFindAndReplaceConfig from './validateFindAndReplaceConfig';
import validateHideColumnsConfig from './validateHideColumnsConfig';
import validateLookUpConfig from './validateLookUpConfig';
import validateParameterOptimizationConfigurationConfig from './validateParameterOptimizationConfigurationConfig';
import validatePivotConfig from './validatePivotConfig';
import validateRenameColumnsConfig from './validateRenameColumnsConfig';
import validateRetypeColumnsConfig from './validateRetypeColumnsConfig';
import validateSortConfig from './validateSortConfig';
import validateUnpivotConfig from './validateUnpivotConfig';
import validateWindowFunctionsConfig from './validateWindowFunctionsConfig';

const VALIDATION_FNS = [
  validateAggregateConfig,
  validateComputedColumnConfig,
  validateDefineTemplateVariablesConfig,
  validateFilterConfig,
  validateFindAndReplaceConfig,
  validateHideColumnsConfig,
  validateLookUpConfig,
  validateParameterOptimizationConfigurationConfig,
  validatePivotConfig,
  validateRenameColumnsConfig,
  validateRetypeColumnsConfig,
  validateSortConfig,
  validateUnpivotConfig,
  validateWindowFunctionsConfig,
] satisfies Array<AdditionalConfigValidationFunctions<PipelineStepType, number>>;

/**
 * Get additional step config validation functions for a given step type and version.
 *
 * If no additional validation function is defined, no-op `() => []` functions are returned.
 */
export function getAdditionalConfigValidationFn<
  StepType extends PipelineStepType,
  StepVersion extends number,
>(
  stepType: StepType,
  stepVersion: StepVersion
): {
  validateConfig: ConfigValidationFunction<StepType, StepVersion>;
  validateDraftConfig: ConfigValidationFunction<StepType, StepVersion, 'draft'>;
} {
  const validationFns = VALIDATION_FNS.find(
    (fns) => fns.stepType === stepType && fns.stepVersion === stepVersion
  ) as AdditionalConfigValidationFunctions<StepType, StepVersion> | undefined;

  return {
    validateConfig: () => [],
    validateDraftConfig: () => [],
    ...(validationFns ?? {}),
  };
}
